import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import VirtualElementPopper from './VirtualElementPopper';
import ClientProvider from './client';
export default createDemo(import.meta.url, VirtualElementPopper, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/popper/demos/virtual-element/VirtualElementPopper.tsx",
    "fileName": "VirtualElementPopper.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Popper from '@mui/material/Popper';\nimport type { PopperProps } from '@mui/material/Popper';\nimport Typography from '@mui/material/Typography';\nimport Fade from '@mui/material/Fade';\nimport Paper from '@mui/material/Paper';\n\nexport default function VirtualElementPopper() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const [open, setOpen] = React.useState(false);\n  const [anchorEl, setAnchorEl] = React.useState<PopperProps['anchorEl']>(null);\n\n  const previousAnchorElPosition = React.useRef<DOMRect>(undefined);\n\n  React.useEffect(() => {\n    if (anchorEl) {\n      if (typeof anchorEl === 'object') {\n        previousAnchorElPosition.current = anchorEl.getBoundingClientRect();\n      } else {\n        previousAnchorElPosition.current = anchorEl().getBoundingClientRect();\n      }\n    }\n  }, [anchorEl]);\n\n  const handleClose = () => {\n    setOpen(false);\n  };\n\n  const handleMouseUp = () => {\n    const selection = window.getSelection();\n\n    // Resets when the selection has a length of 0\n    if (!selection || selection.anchorOffset === selection.focusOffset) {\n      handleClose();\n      return;\n    }\n\n    const getBoundingClientRect = () => {\n      if (selection.rangeCount === 0 && previousAnchorElPosition.current) {\n        setOpen(false);\n        return previousAnchorElPosition.current;\n      }\n      return selection.getRangeAt(0).getBoundingClientRect();\n    };\n\n    setOpen(true);\n\n    setAnchorEl({ getBoundingClientRect });\n  };\n\n  const id = open ? 'virtual-element-popper' : undefined;\n\n  return (\n    <div onMouseLeave={handleClose}>\n      <Typography aria-describedby={id} onMouseUp={handleMouseUp}>\n        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam ipsum purus,\n        bibendum sit amet vulputate eget, porta semper ligula. Donec bibendum\n        vulputate erat, ac fringilla mi finibus nec. Donec ac dolor sed dolor\n        porttitor blandit vel vel purus. Fusce vel malesuada ligula. Nam quis\n        vehicula ante, eu finibus est. Proin ullamcorper fermentum orci, quis finibus\n        massa. Nunc lobortis, massa ut rutrum ultrices, metus metus finibus ex, sit\n        amet facilisis neque enim sed neque. Quisque accumsan metus vel maximus\n        consequat. Suspendisse lacinia tellus a libero volutpat maximus.\n      </Typography>\n      <Popper\n        id={id}\n        open={open}\n        anchorEl={anchorEl}\n        transition\n        placement=\"bottom-start\"\n      >\n        {({ TransitionProps }) => (\n          <Fade {...TransitionProps} timeout={350}>\n            <Paper>\n              <Typography sx={{ p: 2 }}>The content of the Popper.</Typography>\n            </Paper>\n          </Fade>\n        )}\n      </Popper>\n    </div>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 81,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Popper from '@mui/material/Popper';\nimport type { PopperProps } from '@mui/material/Popper';\nimport Typography from '@mui/material/Typography';\nimport Fade from '@mui/material/Fade';\nimport Paper from '@mui/material/Paper';\n\nexport default function VirtualElementPopper() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const [open, setOpen] = React.useState(false);\n  const [anchorEl, setAnchorEl] = React.useState<PopperProps['anchorEl']>(null);\n\n  const previousAnchorElPosition = React.useRef<DOMRect>(undefined);\n\n  React.useEffect(() => {\n    if (anchorEl) {\n      if (typeof anchorEl === 'object') {\n        previousAnchorElPosition.current = anchorEl.getBoundingClientRect();\n      } else {\n        previousAnchorElPosition.current = anchorEl().getBoundingClientRect();\n      }\n    }\n  }, [anchorEl]);\n\n  const handleClose = () => {\n    setOpen(false);\n  };\n\n  const handleMouseUp = () => {\n    const selection = window.getSelection();\n\n    // Resets when the selection has a length of 0\n    if (!selection || selection.anchorOffset === selection.focusOffset) {\n      handleClose();\n      return;\n    }\n\n    const getBoundingClientRect = () => {\n      if (selection.rangeCount === 0 && previousAnchorElPosition.current) {\n        setOpen(false);\n        return previousAnchorElPosition.current;\n      }\n      return selection.getRangeAt(0).getBoundingClientRect();\n    };\n\n    setOpen(true);\n\n    setAnchorEl({ getBoundingClientRect });\n  };\n\n  const id = open ? 'virtual-element-popper' : undefined;\n\n  return (\n    <div onMouseLeave={handleClose}>\n      <Typography aria-describedby={id} onMouseUp={handleMouseUp}>\n        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam ipsum purus,\n        bibendum sit amet vulputate eget, porta semper ligula. Donec bibendum\n        vulputate erat, ac fringilla mi finibus nec. Donec ac dolor sed dolor\n        porttitor blandit vel vel purus. Fusce vel malesuada ligula. Nam quis\n        vehicula ante, eu finibus est. Proin ullamcorper fermentum orci, quis finibus\n        massa. Nunc lobortis, massa ut rutrum ultrices, metus metus finibus ex, sit\n        amet facilisis neque enim sed neque. Quisque accumsan metus vel maximus\n        consequat. Suspendisse lacinia tellus a libero volutpat maximus.\n      </Typography>\n      <Popper\n        id={id}\n        open={open}\n        anchorEl={anchorEl}\n        transition\n        placement=\"bottom-start\"\n      >\n        {({ TransitionProps }) => (\n          <Fade {...TransitionProps} timeout={350}>\n            <Paper>\n              <Typography sx={{ p: 2 }}>The content of the Popper.</Typography>\n            </Paper>\n          </Fade>\n        )}\n      </Popper>\n    </div>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 81,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Popper",
      "@mui/material/Typography",
      "@mui/material/Fade",
      "@mui/material/Paper"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
